module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"and":" and "},"fr":{"and":" et "}}')
  delete Component.options._Ctor
}
